const selectors = {
  holder: 'recommendation-products',
  slider: '.slick',
};
const classes = {
  hide: 'hide',
};
const attributes = {
  URL: 'data-url',
};
class RecommendationProducts extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    fetch(this.getAttribute(attributes.URL))
      .then((response) => response.text())
      .then((data) => {
        const recommendations = new DOMParser().parseFromString(data, 'text/html').querySelector(selectors.holder);
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initSlick();
        } else {
          this.classList.add(classes.hide);
        }
      });
  }

  initSlick() {
    const slider = this.querySelector(selectors.slider);
    const options = JSON.parse(slider.getAttribute('data-slider-options'));

    document.dispatchEvent(new CustomEvent('theme:init-slider', {
      detail: {
        slickHolder: slider.getAttribute('id'),
        slickOptions: options
      }
    }))
  }
}
customElements.get(selectors.holder) || customElements.define(selectors.holder, RecommendationProducts);
